/**
 * Normalizes an email address for identity comparisons and persistence.
 */
export function normalizeEmailAddress(email: string): string {
    return email.trim().toLowerCase()
}

/**
 * Normalizes an optional email and returns undefined for empty input.
 */
export function normalizeOptionalEmailAddress(email?: string | null): string | undefined {
    if (!email) return undefined

    const normalizedEmail = normalizeEmailAddress(email)
    return normalizedEmail.length > 0 ? normalizedEmail : undefined
}
